import { Outlet } from "react-router-dom";
import { IntegrationList } from "./IntegrationList";
import IntegrationForm from "./IntegrationForm";

export const integrationsRoutes = [
  {
    path: "integrations",
    element: Outlet,
    children: [
      {
        path: "",
        element: IntegrationList,
      },
      {
        path: "add",
        element: IntegrationForm,
      },
      {
        path: "edit/:id",
        element: IntegrationForm,
      },
    ],
  },
];
